import React from 'react'
import {
    Box,
    FormControlLabel,
    IconButton,
    Switch,
    Typography,
} from '@material-ui/core'
import { Delete as DeleteIcon } from '@material-ui/icons'
import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
    wrap: {
        position: 'relative',
        marginBottom: theme.spacing(0.5),
        padding: theme.spacing(1, 1, 0.25, 1),
        borderRadius: 8,
        border: '1px dashed transparent',
        '&:hover': {
            borderColor: '#cbd5e1',
            backgroundColor: '#f8fafc',
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: theme.spacing(0.5),
        minHeight: 32,
        marginBottom: theme.spacing(0.5),
    },
    requiredLabel: {
        fontSize: '0.75rem',
        color: '#6b7280',
    },
    lockedHint: {
        fontSize: '0.75rem',
        color: '#9ca3af',
        marginRight: theme.spacing(1),
    },
}))

interface GuestCardFieldEditorChromeProps {
    locked?: boolean
    required: boolean
    onToggleRequired?: (required: boolean) => void
    onRemove?: () => void
    children: React.ReactNode
}

export const GuestCardFieldEditorChrome: React.FC<GuestCardFieldEditorChromeProps> = ({
    locked = false,
    required,
    onToggleRequired,
    onRemove,
    children,
}) => {
    const classes = useStyles()

    return (
        <Box className={classes.wrap}>
            <Box className={classes.toolbar}>
                {locked ? (
                    <Typography className={classes.lockedHint}>
                        Required
                    </Typography>
                ) : (
                    <>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={required}
                                    onChange={(e) =>
                                        onToggleRequired?.(e.target.checked)
                                    }
                                    color="primary"
                                    size="small"
                                />
                            }
                            label={
                                <Typography className={classes.requiredLabel}>
                                    Required
                                </Typography>
                            }
                        />
                        <IconButton
                            size="small"
                            onClick={onRemove}
                            aria-label="Remove question"
                            style={{ color: '#ef4444' }}
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </>
                )}
            </Box>
            {children}
        </Box>
    )
}
